import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileCaptureService } from 'app/service/file-capture.service';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { FileServiceService } from '../service/file-service.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { NotificationService } from 'app/service/notification-service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
    isFirst: any = true;
    files: any = [];
    showError: boolean = false;
    errorMsg: string = '';
    acceptedFiles: string = '.doc, .docx, .dcm, .pdf, .xls, .xlsx, .jpeg, .jpg, .bmp, .png, .tif, .tiff, .wav, .mp3, .txt, .text/plain, .mkv, .eml';
    FilesToUpload: any = [];
    canUpload: boolean = true;
    isViewOnly: boolean = false;
    isLoading: boolean = false;
    BufferChunkSize: any;
    hasUpdate: boolean;
    isDisabled: boolean = true;
    notification: NotificationService;
    fileUploadMap: any = {};
    queue: any = [];
    totalUploadedFiles: any = 0;
    constructor(
        private route: Router, 
        private fcservice: FileCaptureService, 
        public service: FileServiceService, 
        private filesize: FileSizePipe, 
        private http: HttpClient,
        public notificationService: NotificationService
    ) {
    }

    ngOnInit(): void {
    this.notification = this.notificationService;
    const refData = this.service.getCache('contactEmail');
    if (refData) {
        this.service.setPageVisited('reference');
    }

    this.service.setPageVisited('file-upload');

    const cachedFiles = this.service.getCache('files');
    if (cachedFiles) {
        this.files = cachedFiles;
        this.FilesToUpload = cachedFiles;
        this.service.referenceFileDetails.files = cachedFiles;
        this.isDisabled = this.files.length === 0;
        this.totalUploadedFiles = this.files.length;
    }
    }


    next() {
        this.files.forEach((file: File) => {
            const index = this.service.referenceFileDetails.files.findIndex(x => x.name === file.name);
            if (index === -1) {
                this.service.referenceFileDetails.files.push(file);
            }
        });
        this.route.navigate(['review-files']);
    }
    @HostListener('window:dragover', ['$event'])
    allowDrag(e) {

        e.dataTransfer.dropEffect = 'copy';
    }

    @HostListener('window:drop', ['$event'])
    handleDrop(e) {
        this.uploadFiles(e.dataTransfer.files);
    }
    onFileChange(event: any) {
        const pFileList = event.files ? event.files : event;
        if (pFileList.length > 500) {
            this.showError = true;
            this.errorMsg = "Maximum of 500 files can be uploaded";
            return;
        }
        for (let index = 0; index < pFileList.length; index++) {
            const element = pFileList[index];
            const [size, unit] = this.filesize.transform(element.size).split(' ');
            if (parseFloat(size) > 1.5 && unit === 'GB') {
                this.showError = true;
                this.errorMsg = "Files size should be less than 1.5 GB" + ', ' + element.name;
                return;
            } else {
                this.showError = false;
            }
        }
        this.isDisabled = true;
        this.uploadFiles(event);
    }


    uploadFiles(event: any) {
        var files = event.files ? event.files : event;
        let fileArray: any = [];
        fileArray = [files];
        let duplicateFileExist: boolean = false;
        fileArray.forEach((item: any) => {
            if (item instanceof FileList) {
                this.FilesToUpload.forEach( arr => {
                    if(!duplicateFileExist) {
                        duplicateFileExist = Array.from(item).some(b => b.name == arr.fileName);
                    }
                });
            } else if (Array.isArray(item)) {
                this.FilesToUpload.forEach( arr => {
                    if(!duplicateFileExist) {
                        duplicateFileExist = item.some(b => b.name == arr.fileName);
                    }
                });
            }
        });
        
        if (files.length > 0 && !duplicateFileExist) {
            let arrayfiles: File[] = [];
            fileArray.forEach((item: any) => {
                if (item instanceof FileList) {
                    arrayfiles.push(...Array.from(item));
                    this.fcservice.fileArray.push(...Array.from(item));
                } else if (Array.isArray(item)) {
                    arrayfiles.push(...item);
                    this.fcservice.fileArray.push(...item);
                }
            });
            for (let i = 0; i < files.length; i++) {

                if (arrayfiles[i].name !== undefined) {
                    var attachment = { fileName: "", fileType: "", percentage: 0, fileSize: 0, sizeReadable: 0, isFirst: false };

                    attachment.fileName = arrayfiles[i].name.substring(arrayfiles[i].name.lastIndexOf('\\') + 1);
                    attachment.fileType = arrayfiles[i].name.substring(arrayfiles[i].name.lastIndexOf('.') + 1, arrayfiles[i].name.length);
                    if (this.service.getCache('attachmentSaved') == null) {
                        attachment.isFirst = true;
                    }
                    this.FilesToUpload.push(attachment);
                } var index = this.FilesToUpload.findIndex(x => x.fileName === arrayfiles[i].name);
                if (index > -1) {
                    this.FilesToUpload[index].percentage = 0;
                    this.FilesToUpload[index].noOfchunksSent = 0;
                    this.FilesToUpload[index].fileSize = files[i].size !== undefined ? files[i].size : 0;
                    this.FilesToUpload[index].fileId = i;
                    this.FilesToUpload[index].sizeReadable = this.humanFileSize(this.FilesToUpload[index].fileSize, true);
                    this.FilesToUpload[index].activityName = 'Deconfliction';

                    this.FilesToUpload[index].attachmentLength = files[i].size;
                    this.FilesToUpload[index]["targetFile"] = files[i];
                    this.FilesToUpload[index].referenceId = this.service.getCache('referenceId');
                    this.FilesToUpload[index].isUpload = 1;
                }
            }
            this.service.setCacheForitems([{ id: "files", value: this.FilesToUpload }]);
            this.files = this.service.getCache('files');
            this.isDisabled = false;
        }
        else if (duplicateFileExist) {
            this.isDisabled = false;
        }
    }

    humanFileSize(bytes: any, si: any) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    checkFileType(fileType) {
        switch (fileType.toLowerCase()) {
            case "doc":
                return true;
            case "docx":
                return true;
            case "pdf":
                return true;
            case "xls":
                return true;
            case "xlsx":
                return true;
            case "jpeg":
                return true;
            case "jpg":
                return true;
            case "bmp":
                return true;
            case "png":
                return true;
            case "tif":
                return true;
            case "tiff":
                return true;
            case "wav":
                return true;
            case "mp3":
                return true;
            case "txt":
                return true;
            case "text/plain":
                return true;
            case "htm":
                return true;
            case "html":
                return true;
            case "csv":
                return true;
            case "ppt":
                return true;
            case "pptx":
                return true;
            case "eml":
                return true;
            default:
                return false;
        }
    }

    back() {
        this.route.navigate(['reference']);
    }

    cancel() {
        this.service.referenceFileDetails.referenceId = "";
        this.service.clearCache();
        let url = window.localStorage.getItem('securityCode');
        this.route.navigate(['/' + url]);
    }

    onUpload(files: any): void {
        var i = 0;
        for (const file of files) {
            const formData = new FormData();
            var jsonData = JSON.stringify({
                referenceid: this.service.getCache('referenceId'),
                activityName: 'Deconfliction',
                isFirst: i == 0
            });

            formData.append('jsonData', jsonData);
            formData.append('files', file, file.name);
            i++;
            this.fcservice.addFilesToDB(formData).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    console.log('Upload Progress: ' + Math.round(100 * event.loaded / event.total) + '%');
                } else if (event.type === HttpEventType.Response) {
                    console.log('Upload complete');
                }
            });
        }

    }
    closeNotification(index: number) {
        this.notification.queue.splice(index, 1);
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
        this.FilesToUpload.splice(index, 1);
        this.service.setCacheForitems([{ id: "files", value: this.FilesToUpload }]);
        if (this.FilesToUpload.length == 0) {
            this.isDisabled = true;
        }
    }
}
